import React from 'react';
import styles from './CollectionEmptyState.module.scss';
import { Button } from 'components/Button/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import eggImg from '../../assets/img/egg/egg1.jpg';
import gribbleImg from '../../assets/img/egg/gribble-placeholder.png';
import breakerImg from '../../assets/img/break25.jpg';
import { CollectionFetchType } from './model';
import { Link } from 'react-router-dom';
import { routes } from '../../routing/routes';
import { externalRoutes } from '../../routing/externalRoutes';

type PopupCtaProps = {
  title: string;
  cta: React.ReactNode;
  image: string;
};

function PopupCta({ title, cta, image }: PopupCtaProps) {
  return (
    <div className={styles.collectionEmptyBox}>
      <div className={styles.grey1}></div>
      <div className={styles.grey2}></div>
      <div className={styles.centerImage}>
        <LazyLoadImage src={image} className={styles.image} />
      </div>
      <div className={styles.participateText}>
        <p className="subheading-small">{title}</p>
      </div>
      <div className={styles.hatchButton}>{cta}</div>
    </div>
  );
}
const DuskbreakerCTA = React.memo(() => (
  <PopupCta
    title="Get your first DuskBreaker"
    cta={
      <a href={externalRoutes.openSea()} target="_blank" rel="noreferrer noopener">
        <Button small fullWidth primary>
          Buy Now On OpenSea
        </Button>
      </a>
    }
    image={breakerImg}
  />
));

DuskbreakerCTA.displayName = 'DuskbreakerCTA';

const EggCTA = React.memo(() => (
  <PopupCta
    title="Egg Mint is live right now!"
    cta={
      <Link to={routes.mint()}>
        <Button small fullWidth primary>
          Mint Your Egg Now
        </Button>
      </Link>
    }
    image={eggImg}
  />
));

EggCTA.displayName = 'EggCTA';

const GribbleCTA = React.memo(() => (
  <PopupCta
    title="Participate in Gribble hatchening"
    cta={
      <Link to={routes.hatchening()}>
        <Button small fullWidth primary>
          Hatch Your First Gribble
        </Button>
      </Link>
    }
    image={gribbleImg}
  />
));

GribbleCTA.displayName = 'GribbleCTA';

const components: Record<CollectionFetchType, React.ReactNode> = {
  all: (
    <div className={styles.collectionEmptyGrid}>
      <DuskbreakerCTA />
      <EggCTA />
      <GribbleCTA />
    </div>
  ),
  eggs: <EggCTA />,
  gribbles: <GribbleCTA />,
  duskbreakers: <DuskbreakerCTA />,
};

export function CollectionEmptyState({ filterType }: { filterType: CollectionFetchType }) {
  let headerText: string;
  let subText: string;

  if (filterType === 'duskbreakers') {
    headerText = 'DuskBreakers';
    subText = 'DuskBreakers collection';
  } else if (filterType === 'gribbles') {
    headerText = 'Gribbles';
    subText = 'Gribble collection';
  } else if (filterType === 'eggs') {
    headerText = 'Gribble Eggs';
    subText = 'Gribble Eggs';
  } else {
    headerText = 'NFTs';
    subText = 'collections';
  }
  return (
    <div className={styles.collectionEmptyBoxContainer}>
      <h3 className="subheading-large">{"You don't own any " + headerText + ' right now'}</h3>
      <p>{'Get your first NFT from our ' + subText}</p>
      {components[filterType]}
    </div>
  );
}
